/**
 * SCRIPT: z-hero-carousel.js
 * DESCRIÇÃO: Carrossel do hero (SiteBand) — slides, dots, setas, autoplay, altura estável.
 * CHAMADO POR: sections/z-hero-banca.liquid
 * CONTRATO: data-z-hero-carousel; data-slide; data-hero-prev/next/dot
 */
(function () {
  function init(root) {
    var viewport = root.querySelector('.z-hero-carousel__viewport');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if (slides.length < 2 || !viewport) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed') || '6000', 10);
    var index = 0;
    var timer = null;
    var touchX = null;

    function equalize() {
      var max = 0;
      slides.forEach(function (slide) {
        slide.style.minHeight = '';
        slide.style.position = 'relative';
        slide.style.visibility = 'hidden';
        slide.style.opacity = '0';
        slide.style.pointerEvents = 'none';
        max = Math.max(max, slide.offsetHeight);
      });
      viewport.style.minHeight = max + 'px';
      slides.forEach(function (slide, n) {
        var on = n === index;
        slide.style.minHeight = max + 'px';
        slide.style.position = on ? 'relative' : 'absolute';
        slide.style.visibility = on ? 'visible' : 'hidden';
        slide.style.opacity = on ? '1' : '0';
        slide.style.pointerEvents = on ? 'auto' : 'none';
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      var active = slides[index];
      if (active && active.scrollHeight > max) {
        max = active.scrollHeight;
        viewport.style.minHeight = max + 'px';
        slides.forEach(function (slide) {
          slide.style.minHeight = max + 'px';
        });
      }
    }

    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        var on = n === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        slide.style.position = on ? 'relative' : 'absolute';
        slide.style.visibility = on ? 'visible' : 'hidden';
        slide.style.opacity = on ? '1' : '0';
        slide.style.pointerEvents = on ? 'auto' : 'none';
      });
      dots.forEach(function (dot, n) {
        var on = n === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () {
        go(index + 1);
      }, speed);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1); start(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(parseInt(dot.getAttribute('data-hero-dot'), 10));
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    root.addEventListener('touchstart', function (e) {
      touchX = e.changedTouches[0].screenX;
      stop();
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchX == null) return;
      var dx = e.changedTouches[0].screenX - touchX;
      touchX = null;
      if (Math.abs(dx) < 40) { start(); return; }
      go(dx < 0 ? index + 1 : index - 1);
      start();
    }, { passive: true });

    function afterImages(cb) {
      var imgs = root.querySelectorAll('img');
      var left = imgs.length;
      if (!left) { cb(); return; }
      var done = function () {
        left -= 1;
        if (left <= 0) cb();
      };
      imgs.forEach(function (img) {
        if (img.complete) done();
        else {
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        }
      });
    }

    afterImages(function () {
      equalize();
      go(0);
      start();
    });
    window.addEventListener('resize', function () {
      equalize();
      go(index);
    });
  }

  function boot() {
    document.querySelectorAll('[data-z-hero-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
